import React from "react";
// import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import { useSearchParams } from "react-router-dom";

function Network() {
  const [searchParams] = useSearchParams();
  const firstName = searchParams.get("first_name");
  const title = firstName ? `Great talking with you, ${firstName}` : "Great talking with you";

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/journey", label: "Our Journey" },
    { to: "/blog", label: "Blogs & Insights" },
    { to: "/get-in-touch", label: "Support" },
  ];

  return (
    <>
      <head>
        <title>{title} | DataPulse AI</title>
        {/* <meta name="robots" content="noindex, nofollow" /> */}

      </head>

      <div className="h-screen w-screen overflow-hidden flex flex-col">
        <div id="header" className="z-10 bg-white">
          <Header links={navLinks} />
        </div>

        <section id="network" className="flex-1 bg-white flex items-center h-screen w-screen justify-center">
          <div className="max-w-screen-xl px-4 pt-10 text-center">
            <div className="mx-auto text-center">
              <h2 className="mb-1 text-3xl font-extrabold tracking-tight">{title}</h2>
              <p className="mb-3 font-light text-gray-500 sm:text-xl dark:text-gray-400">
                How would you like to stay in touch?
              </p>
            </div>
            <div className="space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 xl:gap-10">
            {/* Appointment Card */}
            <a
              href="https://www.mydatapulse.co.uk/appointment"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row lg:max-w-sm mx-auto items-center gap-4 p-3 text-left bg-gray-50 dark:bg-gray-800 border border-purple-700 hover:bg-purple-100 dark:border-gray-600 rounded-lg shadow transition"
            >
              <img src="/assets/images/calendar.png" alt="Calendar icon" className="w-12 h-12 object-contain" />
              <div>
                <h3 className="mb-1 text-2xl font-semibold text-purple-700 dark:text-purple-400">Continue the Chat</h3>
                <p className="text-gray-500 dark:text-gray-400 text-sm">Book a 15-min call to pick up where we left off.</p>
              </div>
            </a>

            {/* LinkedIn Card */}
            <a
              href="https://www.linkedin.com/in/viren-samani"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row lg:max-w-sm mx-auto items-center gap-4 p-3 text-left bg-gray-50 dark:bg-gray-800 border border-purple-700 hover:bg-purple-100 dark:border-gray-600 rounded-lg shadow transition"
            >
              <img src="/icons/linkedin.svg" alt="LinkedIn icon" className="w-12 h-12 object-contain" />
              <div>
                <h3 className="mb-1 text-2xl font-semibold text-purple-700 dark:text-purple-400">LinkedIn</h3>
                <p className="text-gray-500 dark:text-gray-400 text-sm">Connect on LinkedIn.</p>
              </div>
            </a>

            {/* WhatsApp Card */}
            <a
              href="https://api.whatsapp.com/send/?phone=447447151608&text=Hi%20DataPulse!%20%F0%9F%91%8B%F0%9F%8F%BD%20I%27m%20interested%20in%20how%20you%20can%20help%20grow%20my%20business%20%F0%9F%9A%80"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row lg:max-w-sm mx-auto items-center gap-4 p-3 text-left bg-gray-50 dark:bg-gray-800 border border-purple-700 hover:bg-purple-100 dark:border-gray-600 rounded-lg shadow transition"
            >
              <img src="assets/images/whatsapp-chatbot.png" alt="WhatsApp icon" className="w-12 h-12 object-contain" />
              <div>
                <h3 className="mb-1 text-2xl font-semibold text-purple-700 dark:text-purple-400">WhatsApp Demo</h3>
                <p className="text-gray-500 dark:text-gray-400 text-sm">Talk to Pulse - our WhatsApp Support AI.</p>
              </div>
            </a>

            {/* Talk to Human Card */}
            <a
              href="https://api.whatsapp.com/send/?phone=+447447164108&text=Hi%20team!%20%F0%9F%91%8B%F0%9F%8F%BD%20I%27m%20interested%20in%20learning%20more%20about%20about%20DataPulse%20AI%20can%20help%20my%20business%20%F0%9F%9A%80"
              className="flex flex-row lg:max-w-sm mx-auto items-center gap-4 p-3 text-left bg-gray-50 dark:bg-gray-800 border border-purple-700 hover:bg-purple-100 dark:border-gray-600 rounded-lg shadow transition"
            >
              <img src="/assets/images/whatsapp.svg" alt="Phone icon" className="w-12 h-12 object-contain" />
              <div>
                <h3 className="mb-1 text-2xl font-semibold text-purple-700 dark:text-purple-400">Talk to Viren</h3>
                <p className="text-gray-500 dark:text-gray-400 text-sm">Connect on WhatsApp directly.</p>
              </div>
            </a>
            <h3 style={{ fontSize: "2.5rem", paddingTop: "1.5rem", lineHeight:"0" }} className="font-extrabold tracking-tight text-title-purple">
              Viren Samani
            </h3>
            <h4 style={{ fontSize: "1.15rem", paddingTop: "1rem", lineHeight:"0" }} className="text-gray-500">Founder & CEO</h4>
            {/* Homepage */}
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col justify-between text-center transition"
            >
              <div className="w-full max-w-sm mx-auto lg:max-w-sm px-8">
                <img
                  className="w-full h-auto"
                  src="https://www.mydatapulse.co.uk/icons/1.png"
                  alt="logo image"
                />
              </div>
            </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Network;
